import type { PrivateXModulesOptions, XModulesOptions } from '@empathyco/x-components'
import type { SearchBoxState } from '@empathyco/x-components/search-box'
import { namespacedWireCommit } from '@empathyco/x-components'

const moduleName = 'searchBox'
const wireCommit = namespacedWireCommit(moduleName)
const clearPreviousQueryWire = wireCommit('setPreviousQuery', '')

export const searchBoxOptions: XModulesOptions['searchBox'] = {
  wiring: {
    UserPressedClearSearchBoxButton: {
      clearPreviousQueryWire,
    },
  },
}

export const searchBoxPrivateOptions: PrivateXModulesOptions['searchBox'] = {
  storeModule: {
    state: {
      previousQuery: null,
    },
    mutations: {
      setQuery(state: SearchBoxState, query: string) {
        state.previousQuery = state.query
        state.query = query
      },
      setPreviousQuery(state: SearchBoxState, previousQuery: string) {
        state.previousQuery = previousQuery
      },
    },
  },
  storeEmitters: {
    UserClearedQuery: {
      selector: state => state.query,
      filter(newValue, _, state): boolean {
        return (!newValue || newValue.length === 0) && !state.previousQuery
      },
    },
  },
}
